var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"text":_vm.$t('ClientSearchButton:Text'),"size":"wide","color":"accent","icon":"search","disabled":_vm.isLoading || _vm.isSearching || !_vm.code,"is-loading":_vm.isSearching,"loading-left":true},on:{"click":_vm.search}})
}
var staticRenderFns = []

export { render, staticRenderFns }